import { Waves } from "lucide-react";
import { Image } from "@/components/ui/image";

/**
 * Photo slot for a beach: the real shot once one is set in the beach data,
 * otherwise a labeled placeholder that holds the space. `compact` drops the
 * label for thumbnails too small to read it.
 */
export default function BeachPhoto({ beach, compact = false }) {
  if (beach.image) {
    return (
      <Image
        src={beach.image}
        alt={beach.name}
        fittingType="fill"
        className="w-full h-full object-cover"
      />
    );
  }

  return (
    <span className="w-full h-full flex flex-col items-center justify-center gap-1.5 bg-[#F7F3EC]">
      <Waves className={`${compact ? "w-4 h-4" : "w-5 h-5"} text-[#C9A227]`} />
      {!compact && (
        <span className="text-[9px] tracking-[0.16em] uppercase font-black text-[#A89678]">
          Photo coming soon
        </span>
      )}
    </span>
  );
}